import React, { useState } from "react";
import { apis } from "../apis";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import "./Login.css";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string()
      .required("البريد الالكتروني مطلوب")
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setError("");

      try {
        const response = await apis.forgotPassword(values.email);

        if (response.status === "success") {
          navigate("/checkotp-reset-password", { state: { email: values.email } });
        } else {
          setError(response.msg || "فشل في إرسال رمز OTP.");
        }
      } catch (err) {
        setError("حدث خطأ أثناء إرسال رمز التحقق.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1 className="auth-title">استعادة كلمة المرور</h1>
          <form onSubmit={formik.handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">البريد الالكتروني</label>
              <div className="input-with-icon">
                <Mail size={18} className="input-icon" />
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="أدخل بريدك الإلكتروني"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={formik.touched.email && formik.errors.email ? "error" : ""}
                />
              </div>
              {formik.touched.email && formik.errors.email && (
                <div className="error-message">{formik.errors.email}</div>
              )}
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? (
                <span className="loading-spinner"></span>
              ) : (
                <>
                  <span>إرسال رمز OTP</span>
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>
          
          <div className="auth-footer">
            <p>
              تذكرت كلمة المرور؟{" "}
              <button 
                className="btn-link" 
                onClick={() => navigate("/login")}
              >
                تسجيل الدخول
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
